var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"do-not-print"},[_c('stepper-header',{attrs:{"steps":_vm.steps,"currentStep":_vm.currentStep}})],1),_c('div',{staticClass:"stepper-content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }